import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc.js';
import {strEncode,strDecode} from '../../encrpt.js';
import DataTable from 'react-data-table-component';
import TableSearch from "./TableSearch.js";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


function Participants() {
    const navigate = useNavigate();
	const [userData, setUserData] = useState(null);

   useEffect(() => {
  const authToken = localStorage.getItem("authToken");
   
  if (!authToken) {
    localStorage.removeItem("user");
    navigate(""); // Redirect to login or home
  } else {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (storedUser) {
		console.log("storeduser",storedUser)
        setUserData(storedUser);
      } else {
        console.warn("User data missing or malformed");
      }
    } catch (err) {
      console.error("Failed to parse user data:", err);
    }
  }
}, [navigate]);

    useEffect(() => {
			if (userData) {
				 console.log("useedaata",userData)
					var whrc_organization = userData?.usertype > 0 ? "id > 0" : "id = '"+userData?.org+"'";
					console.log("whrc",whrc_organization)
						axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_organization_mst'),whrc :strEncode(whrc_organization) },{ headers: { 'Content-Type': 'application/json' } }) 
					.then( (res) => {
					setOrganizationTypeList(res.data);
					}).catch( (error) => { console.log(error); });
			}
			}, [userData]);

	const [formData, setFormData] = useState({
		n_org_id: userData?.usertype > 0 ? '' : userData?.org,
		c_name: "",
		n_type: "",
		n_profession: "",
		n_if_govt_resident: "",
		n_uid: "",
		n_gender: "",
		n_age: "0",
		n_academic_achivement :'',
		n_phone_no :'',
		n_phone_no_alt :'',
		c_current_residence :'',
		n_if_sole_breadwinner :'',
		n_current_situation :'',
		n_work:'',
		n_if_disabled:''
	  });
	  
	
	 const [errors, setErrors] = useState({});
	 const [organizationtype, setOrganizationTypeList] = useState([]);
     const [participantstype, setParticipantsTypeList] = useState([]);
	 const [participantsprofession, setParticipantsProfessionList] = useState([]);
	 const [participantsacademic, setAcademicAchievement] = useState([]);
	 const [participantsCurrent, setCurrentSituation] = useState([]);
	 const [participantsWork, setWork] = useState([]);
	 const [gender, setGenderList] = useState([]);
	 const [yesno, setYesNoList] = useState([]);
	 const [internes, setRaporteeList] = useState([]);
	 const [columns, setColumns] = useState([]);
	 const [tabledata, settableData] = useState([]);	
	 const [selectedUser, setSelectedUser] = useState(null);
     const [editMode, setEditMode] = useState(false);
     const [modalData, setModalData] = useState(false);
     const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
     const [indiid, setModalId] = useState(null);	
     const [raporteedata, setRapporteeData] = useState({
	  n_stakeholder_id : ""
      });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);
  
  useEffect(() => {


	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_type_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setParticipantsTypeList(res.data);
	    }).catch( (error) => { console.log(error); });


  
	 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_profession_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	   .then( (res) => {
	   setParticipantsProfessionList(res.data);
	   }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_gender_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setGenderList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_yes_no_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setYesNoList(res.data);
	  }).catch( (error) => { console.log(error); });



	   axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_academic_achievement_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setAcademicAchievement(res.data);
	    }).catch( (error) => { console.log(error); });



		 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_current_situation_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setCurrentSituation(res.data);
	    }).catch( (error) => { console.log(error); });


		 axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_participants_work_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
    	.then( (res) => {
	    setWork(res.data);
	    }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_participants_registration'),cols:strEncode('*') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "Actions",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   </div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
		n_org_id: userData?.org == null || userData?.org > 0 ? '' : userData?.org,
	    c_name: "",
		n_type: "",
		n_profession: "",
		n_if_govt_resident: "",
		n_uid: "",
		n_gender: "",
		n_age: "0",
		n_academic_achivement :'',
		n_phone_no :'',
		n_phone_no_alt :'',
		c_current_residence :'',
		n_if_sole_breadwinner :'',
		n_current_situation :'',
		n_work:'',
		n_if_disabled:''
	  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }


  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_participants_registration'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 setFormData({
		id : response.data[0].id,
		n_org_id : response.data[0].n_org_id,
		c_name: response.data[0].c_name,
		n_type: response.data[0].n_type,
		n_profession: response.data[0].n_profession,
		n_if_govt_resident: response.data[0].n_if_govt_resident,
		n_uid:response.data[0].n_uid,
		n_gender: response.data[0].n_gender,
		n_age: response.data[0].n_age,
		n_academic_achivement : response.data[0].n_academic_achivement,
		n_phone_no :response.data[0].n_phone_no,
		n_phone_no_alt :response.data[0].n_phone_no_alt,
		c_current_residence :response.data[0].c_current_residence,
		n_if_sole_breadwinner :response.data[0].n_if_sole_breadwinner,
		n_current_situation :response.data[0].n_current_situation,
		n_work:response.data[0].n_work,
		n_if_disabled:response.data[0].n_if_disabled
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  
   // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
	 /* const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
		  newErrors[name] = "This field is required.";
		} else {
		  delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
		  newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" ) {
		  const validations = validatePassword(value);
		  if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
		  if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
		  if (!validations.number) newErrors[name] = "Password must contain at least one number.";
		  if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
		  if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	  }; */
	

	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "This field is required.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "Invalid email format.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "Password must be at least 12 characters.";
			if (!validations.uppercase) newErrors[name] = "Password must contain at least one uppercase letter.";
			if (!validations.number) newErrors[name] = "Password must contain at least one number.";
			if (!validations.specialChar) newErrors[name] = "Password must contain at least one special character.";
			if (!validations.restrictedChars) newErrors[name] = "Password contains restricted characters.";
		}
	
		setErrors(newErrors);
	};
	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  console.log("formdata afeter",formData)
           const payload = {
				data: {
					...formData,
					n_user_id: userData?.id
				}
				};

		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/participants/register`, payload);
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/participants/update`, { data: formData });
			alert("تم تحديث البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			n_org_id: userData?.org == null || userData?.org > 0 ? '' : userData?.org,
			c_name: "",
			c_username: "",
			c_email: "",
			c_password: "",
			n_phone_no: "",
			n_type: "",
			n_status: "",
		  });
	  
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };

	  

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}
          >
           
           <span className="d-sm-block d-none">قائمة</span>
		  </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}>
            <span className="d-sm-block d-none">إضافة مشارك جديد</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<TableSearch
									title="بيانات المستخدم"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">يكتب</label>
									<div className="col-md-9">
									<select name="n_org_id" className="form-select" onChange={handleChange} value={formData.n_org_id}>
										<option value="">يختار</option>
										{organizationtype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_org_name}</option>
										))}
									</select>
									{errors.n_org_id && <span style={{ color: "red" }}>{errors.n_org_id}</span>}
									</div>
								</div>


							<div className="row mb-15px" key="c_name">
									<label className="form-label col-form-label col-md-3">الاسم الكامل</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_name"
										value={formData.c_name}
										onChange={handleChange}
										/>
                                     {errors.c_name && <span style={{ color: "red" }}>{errors.c_name}</span>}
									</div>
									</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">يكتب</label>
									<div className="col-md-9">
									<select name="n_type" className="form-select" onChange={handleChange} value={formData.n_type}>
										<option value="">يختار</option>
										{participantstype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_type && <span style={{ color: "red" }}>{errors.n_type}</span>}
									</div>
								</div>

								

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">مهنة</label>
									<div className="col-md-9">
									<select name="n_profession" className="form-select" onChange={handleChange} value={formData.n_profession}>
										<option value="">يختار</option>
										{participantsprofession.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_profession && <span style={{ color: "red" }}>{errors.n_profession}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">هل أنت من سكان محافظة نينوى؟ ?</label>
									<div className="col-md-9">
									<select name="n_if_govt_resident" className="form-select" onChange={handleChange} value={formData.n_if_govt_resident}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_if_govt_resident && <span style={{ color: "red" }}>{errors.n_if_govt_resident}</span>}
									</div>
								</div>

									<div className="row mb-15px" key="c_name">
									<label className="form-label col-form-label col-md-3">رقم البطاقة الموحد أو رقم البطاقة المدنية</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_uid"
										value={formData.n_uid}
										onChange={handleChange}
										/>
                                     {errors.n_uid && <span style={{ color: "red" }}>{errors.n_uid}</span>}
									</div>
									</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">جنس</label>
									<div className="col-md-9">
									<select name="n_gender" className="form-select" onChange={handleChange} value={formData.n_gender}>
										<option value="">يختار</option>
										{gender.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_gender && <span style={{ color: "red" }}>{errors.n_gender}</span>}
									</div>
								</div>

								
									<div className="row mb-15px" key="n_age">
									<label className="form-label col-form-label col-md-3">عمر</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_age"
										value={formData.n_age}
										onChange={handleChange}
										/>
                                     {errors.n_age && <span style={{ color: "red" }}>{errors.n_age}</span>}
									</div>
									</div>
                               
							       	<div className="row mb-15px" key="n_academic_achivement">
									<label className="form-label col-form-label col-md-3">التحصيل الأكاديمي</label>
									<div className="col-md-9">
										<select name="n_academic_achivement" className="form-select" onChange={handleChange} value={formData.n_academic_achivement}>
										<option value="">يختار</option>
										{participantsacademic.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									
                                     {errors.n_academic_achivement && <span style={{ color: "red" }}>{errors.n_academic_achivement}</span>}
									</div>
									</div>

                                     <div className="row mb-15px" key="n_phone_no">
									<label className="form-label col-form-label col-md-3">رقم الهاتف</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_phone_no"
										value={formData.n_phone_no}
										onChange={handleChange}
										/>
                                     {errors.n_phone_no && <span style={{ color: "red" }}>{errors.n_phone_no}</span>}
									</div>
									</div>
                               
                    <div className="row mb-15px" key="n_phone_no_alt">
									<label className="form-label col-form-label col-md-3">رقم الهاتف البديل</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="number"
										name= "n_phone_no_alt"
										value={formData.n_phone_no_alt}
										onChange={handleChange}
										/>
                                     {errors.n_phone_no_alt && <span style={{ color: "red" }}>{errors.n_phone_no_alt}</span>}
									</div>
									</div>

									
                    <div className="row mb-15px" key="c_current_residence">
									<label className="form-label col-form-label col-md-3">الإقامة الحالية</label>
									<div className="col-md-9">
										<input
										className="form-control mb-5px"
										type="text"
										name= "c_current_residence"
										value={formData.c_current_residence}
										onChange={handleChange}
										/>
                                     {errors.c_current_residence && <span style={{ color: "red" }}>{errors.c_current_residence}</span>}
									</div>
									</div>

                                   <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">هل أنت المعيل الوحيد للأسرة؟</label>
									<div className="col-md-9">
									<select name="n_if_sole_breadwinner" className="form-select" onChange={handleChange} value={formData.n_if_sole_breadwinner}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_if_sole_breadwinner && <span style={{ color: "red" }}>{errors.n_if_sole_breadwinner}</span>}
									</div>
								</div>

								 <div className="row mb-15px" key="n_current_situation">
									<label className="form-label col-form-label col-md-3">الوضع الحالي</label>
									<div className="col-md-9">
										<select name="n_current_situation" className="form-select" onChange={handleChange} value={formData.n_current_situation}>
										<option value="">يختار</option>
										{participantsCurrent.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									    </select>
                                     {errors.n_current_situation && <span style={{ color: "red" }}>{errors.n_current_situation}</span>}
									</div>
									</div>

									<div className="row mb-15px" key="n_work">
									<label className="form-label col-form-label col-md-3">عمل</label>
									<div className="col-md-9">
										<select name="n_work" className="form-select" onChange={handleChange} value={formData.n_work}>
										<option value="">يختار</option>
										{participantsWork.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									    </select>
                                     {errors.n_work && <span style={{ color: "red" }}>{errors.n_work}</span>}
									</div>
									</div>

								 <div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">عاجز</label>
									<div className="col-md-9">
									<select name="n_if_disabled" className="form-select" onChange={handleChange} value={formData.n_if_disabled}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_if_disabled && <span style={{ color: "red" }}>{errors.n_if_disabled}</span>}
									</div>
								</div>

                               {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">يحفظ</button>
								:
								<button type="submit" className="btn btn-success w-100px">تحديث</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
		
		</div>
	)
}

export default Participants;